import { createStyles } from '@mantine/core'

type StylesParams = {
  isEnd: boolean
  hasUnit?: boolean
}

export default createStyles((theme, { isEnd, hasUnit }: StylesParams) => {
  return {
    root: {
      backgroundColor: isEnd ? theme.colors.gray[1] : '#FAF4E6',
      display: 'flex',
      alignItems: 'center',
      borderRadius: 8,
      justifyContent: 'space-between',
      padding: 4,
    },
    heading: {
      flexGrow: 1,
      textAlign: 'center',
      textTransform: 'uppercase',
      padding: '0 10px',
    },
    listing: {
      display: 'flex',
      alignItems: 'center',
      // backgroundImage:
      //   'linear-gradient(271.93deg, #E64728 25.89%, #FC8A09 131.8%)',
      // backdropFilter: 'blur(16px)',
      ...(hasUnit && {
        marginBottom: 10,
      }),
    },
    item: {
      position: 'relative',
      width: 35,
      height: 32,
      borderRadius: 4,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: isEnd ? '#BFBFBF' : '#FDC42D',
    },
    divider: {
      '&:before': {
        content: '":"',
        display: 'inline-block',
        marginLeft: 4,
        marginRight: 4,
      },
      '&:first-child': {
        '&:before': {
          content: 'none',
        },
      },
    },
    text: {
      fontWeight: 600,
      textAlign: 'center',
    },
    unit: {
      position: 'absolute',
      left: 0,
      right: 0,
      top: '100%',
      textAlign: 'center',
    },
  }
})
